<template>
  <div v-if="proceeding">
    <div class="clearfix mb-1">
      <div class="float-left sub-title bolder"> {{ title }}</div>
      <div class="float-right text-right">
        <save-btn-sm class="mr-1" @click="onSave">저장</save-btn-sm>
        <cancel-btn-sm  @click="onBack()">돌아가기</cancel-btn-sm>
      </div>
    </div>
    <mdb-card class="mb-4">
      <mdb-card-body class="p-2"  v-if="proceeding.info">
        <mdb-row>
          <mdb-col md="12"><mdb-input class="my-1" label="회의명" v-model="proceeding.info.name" :disabled="!isStaff"/></mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="4"><date-picker v-model="proceeding.info.date" label="날짜"  :disabled="!isStaff"/></mdb-col>
          <mdb-col md="2"><mdb-input label="시간" v-model="proceeding.info.time"  :disabled="!isStaff"/></mdb-col>
          <mdb-col md="5"><mdb-input label="회의 장소" v-model="proceeding.info.place"  :disabled="!isStaff"/></mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
    <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 운영 매니저 의견</p>
    <proceeding-comment-edit v-if="who==='MANAGER'" :content="proceeding.manager"/>
    <proceeding-comment-view v-else :content="proceeding.manager"/>

    <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 훈련 강사 의견</p>
    <proceeding-comment-edit v-if="who==='TEACHER'"  :content="proceeding.teacher"/>
    <proceeding-comment-view v-else :content="proceeding.teacher"/>

    <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 총괄 매니저 의견</p>
    <proceeding-comment-edit v-if="who==='CHIEF'" :content="proceeding.chief"/>
    <proceeding-comment-view v-else :content="proceeding.chief"/>
  </div>
</template>
<script>
import { mdbCard, mdbCardBody } from 'mdbvue';
import ProceedingCommentView from '@/components/comm/proceeding/ProceedingCommentView.vue';
import ProceedingCommentEdit from '@/components/comm/proceeding/ProceedingCommentEdit.vue';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'StaffProceedingEditPage',
  components: { mdbCard, mdbCardBody, ProceedingCommentEdit, ProceedingCommentView },
  props: [],
  data: () => ({
    proceeding: undefined
  }),
  computed: {
    ...mapGetters('auth', ['isTeacher', 'isStaff']),
    ...mapState('training', ['training']),
    query () { return this.$route.query },
    who () { return this.$route.query.who },
    title () {
      return this.proceeding.subject + (this.proceeding.lectureName ? ' / ' + this.proceeding.lectureName : '')
    }
  },
  methods: {
    async load () {
      if (!this.training) return
      const { id, subject, lectureName, lectureCode } = this.$route.query
      if (id === 'new') {
        this.proceeding = this.$Proceeding.create(this.training._id, subject, lectureName, lectureCode)
      } else {
        this.proceeding = await this.$Proceeding.get(id)
      }
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      const isNew = !this.proceeding._id
      this.proceeding = await this.proceeding.save()
      if (isNew) {
        this.$router.push({
          name: 'StaffProceedingEditPage',
          query: { id: this.proceeding._id }
        })
      }
    },
    onBack () {
      if (!this.proceeding._id) {
        this.$router.back()
      } else {
        this.$router.push({
          name: 'StaffProceedingViewPage',
          query: { id: this.proceeding._id }
        })
      }
    }
  },
  watch: { training: 'load' },
  created () { this.load() }
}
</script>
